module.exports = __webpack_public_path__ + "img/MING_MSCS.053a3ed1.svg";